<template>
  <el-dialog ref='dialog' :title="导入列" style="min-width:1280px">
    <el-table
      v-if="show"
      :data="fields"
      border
      style="width: 100%"
      max-height="600"
      @selection-change="selectItem">
      <el-table-column
        type="selection"
        :context="_self"
        width="50">
      </el-table-column>
      <el-table-column
        prop="title"
        width="300"
        label="字段标题">
      </el-table-column>
      <el-table-column
        prop="name"
        label="字段名">
      </el-table-column>
    </el-table>

    <div class="footer">
      <el-button @click="closeDialog">返回</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>
  
<script>
import http from '../../../../assets/js/http'
export default {
  props: {
    fields: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      data: [],
      show: false
    }
  },
  created() {
  },
  methods: {
    openDialog() {
      this.show = true
      this.$refs.dialog.open()
    },
    closeDialog() {
      this.$refs.dialog.close()
      this.show = false
    },
    selectItem(value) {
      this.selectRows = value
    },
    submit() {
      this.$emit('importFields', this.selectRows)
      this.selectRows = []
      this.closeDialog()
    }
  },
  mixins: [http]
}
</script>



// WEBPACK FOOTER //
// fieldList.vue?9911f08c